import { createSlice } from "@reduxjs/toolkit";

const deviceEditSlice = createSlice({
  name: "deviceEdit",
  initialState: {
    currentDevice: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    deviceStart: (state) => {
      state.isFetching = true;
    },
    deviceSuccess: (state, action) => {
      state.isFetching = false;
      state.currentDevice = action.payload;
    },
    deviceFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    updateStart: (state) => {
      state.currentDevice = null;
      state.isFetching = true;
      state.error = false;
    },
    updateSuccess: (state, action) => {
      state.isFetching = false;
      state.currentDevice = action.payload;
      state.error = false;
    },
    updateFailure: (state) => {
      state.currentDevice = null;
      state.isFetching = false;
      state.error = true;
    },
    logoutInfoDevice: (state) => {
      state.currentDevice = null;
      state.isFetching = false;
      state.error = false;
    },
  },
});

export const {
  deviceStart,
  deviceSuccess,
  deviceFailure,
  updateStart,
  updateSuccess,
  updateFailure,
  logoutInfoDevice,
} = deviceEditSlice.actions;
export default deviceEditSlice.reducer;
